import axios from 'axios'
import { calls } from '../utils/calls.js'
import { createError } from '../utils/utils.js'

export const getCushionsByCategory = (categoryId) => {
  return axios(calls.getCushionsByCategory(categoryId))
    .then((cushions) => {
      return cushions.data
    })
    .catch((err) => createError(err))
}

export const getAttributeTermsById = (attributeId) => {
  return axios(calls.getAttributeTermsById(attributeId))
    .then((cushions) => {
      return cushions.data
    })
    .catch((err) => createError(err))
}

export const setCushionTypes = (cushionTypes) => {
  return (dispatch) => {
    dispatch({ type: 'SET_CUSHION_TYPES', payload: { cushionTypes: cushionTypes } })
  }
}

export const setCushionShapes = (cushionShapes) => {
  return (dispatch) => {
    dispatch({ type: 'SET_CUSHION_SHAPES', payload: { cushionShapes: cushionShapes } })
  }
}

export const setCushionDimensions = (cushionDimensions) => {
  return (dispatch) => {
    dispatch({ type: 'SET_CUSHION_DIMENSIONS', payload: { cushionDimensions: cushionDimensions } })
  }
}

export const setInitialCushionDimensions = (cushionDimensions) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_INITIAL_CUSHION_DIMENSIONS',
      payload: { cushionDimensions: cushionDimensions },
    })
    return Promise.resolve()
  }
}

export const setCushionFillings = (cushionFillings) => {
  return (dispatch) => {
    dispatch({ type: 'SET_CUSHION_FILLINGS', payload: { cushionFillings: cushionFillings } })
  }
}

export const setCushionFasteners = (cushionFasteners) => {
  return (dispatch) => {
    dispatch({ type: 'SET_CUSHION_FASTENERS', payload: { cushionFasteners: cushionFasteners } })
  }
}

export const setCushionStyles = (cushionStyles) => {
  return (dispatch) => {
    dispatch({ type: 'SET_CUSHION_STYLES', payload: { cushionStyles: cushionStyles } })
  }
}

export const setCushionSets = (cushionSets) => {
  return (dispatch) => {
    dispatch({ type: 'SET_CUSHION_SETS', payload: { cushionSets: cushionSets } })
  }
}

export const setIsHalfInchRemoved = (isHalfInchRemoved) => {
  return (dispatch) => {
    dispatch({ type: 'SET_IS_HALF_INCH_REMOVED', payload: { isHalfInchRemoved } })
  }
}

export const getProductsDeepSeat = () => {
  return axios(calls.getProductsDeepSeat())
    .then((products) => {
      return products.data
    })
    .catch((err) => createError(err))
}

export const getProductsPillow = () => {
  return axios(calls.getProductsPillow())
    .then((products) => {
      return products.data
    })
    .catch((err) => createError(err))
}

export const getProductsCushion = () => {
  return axios(calls.getProductsCushion())
    .then((products) => {
      return products.data
    })
    .catch((err) => createError(err))
}
